// extracted by mini-css-extract-plugin
module.exports = {"twinkling":"Star_twinkling__Rub_n"};